import React, { Component, Fragment } from 'react'
import { Button, TableRow, TableCell, MenuItem } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../../utils/common'
import { hasAccess } from '../../../utils/api'

import { EditableSelect } from '../../common/EditableComponents'
import EditActionComponent from '../../common/EditActionComponent'

export default class WeedMapMenuListItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onChangeWeedmapTags = (index) => (event) => {
    const { value = '' } = event.target
    const { wmTags = [] } = this.props.data || {}
    const updatedWmTags = [...wmTags]
    updatedWmTags[index] = value
    for (let i = index + 1; i < wmTags.length; ++i) {
      updatedWmTags[i] = ''
    }
    this.props.onChange('wmTags', updatedWmTags)
  }

  render() {
    const {
      data,
      categoryList,
      weedMapList,
      editMode,
      version = 1,
      defaultTagMapping = {},
    } = this.props

    const { wmTags = [] } = data || {}

    const selectedCategory = categoryList.find((category) => category.id === data.categoryId) || {}

    const mainCategories =
      (defaultTagMapping['MAIN_CATEGORY'] && defaultTagMapping['MAIN_CATEGORY']['']) || []
    const secondLevelCategories =
      (defaultTagMapping['SECOND_LEVEL'] && defaultTagMapping['SECOND_LEVEL'][wmTags[0] || '']) ||
      []
    const thirdLevelCategories =
      (defaultTagMapping['THIRD_LEVEL'] && defaultTagMapping['THIRD_LEVEL'][wmTags[1] || '']) || []
    const fourthLevelCategories =
      (defaultTagMapping['FOURTH_LEVEL'] && defaultTagMapping['FOURTH_LEVEL'][wmTags[2] || '']) ||
      []

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">
          <EditableSelect
            value={data.categoryId}
            onChange={this.onChange('categoryId')}
            valueToRender={selectedCategory.name}
            editMode={editMode}
            MenuProps={{ className: 'no-backdrop-select' }}
          >
            {categoryList
              .filter((category) => category.active)
              .map((item, index) => {
                return (
                  <MenuItem key={index} value={item.id}>
                    {item.name}
                  </MenuItem>
                )
              })}
          </EditableSelect>
        </TableCell>
        {version === 1 ? (
          <TableCell className="cell-wrap-word">
            <EditableSelect
              value={data.weedmapCategory}
              onChange={this.onChange('weedmapCategory')}
              valueToRender={data.weedmapCategory}
              editMode={editMode}
              MenuProps={{ className: 'no-backdrop-select' }}
            >
              {weedMapList.map((item, index) => {
                return (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                )
              })}
            </EditableSelect>
          </TableCell>
        ) : null}
        {version === 2 ? (
          <Fragment>
            <TableCell>
              <EditableSelect
                value={data.wmTags[0] || ''}
                onChange={this.onChangeWeedmapTags(0)}
                valueToRender={data.wmTags[0] || ''}
                editMode={editMode}
                MenuProps={{ className: 'no-backdrop-select' }}
              >
                {mainCategories.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.name}>
                      {item.name}
                    </MenuItem>
                  )
                })}
              </EditableSelect>
            </TableCell>
            <TableCell>
              <EditableSelect
                value={data.wmTags[1] || ''}
                onChange={this.onChangeWeedmapTags(1)}
                valueToRender={data.wmTags[1] || ''}
                editMode={editMode}
                MenuProps={{ className: 'no-backdrop-select' }}
              >
                {secondLevelCategories.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.name}>
                      {item.name}
                    </MenuItem>
                  )
                })}
              </EditableSelect>
            </TableCell>
            <TableCell>
              {(thirdLevelCategories.length && (
                <EditableSelect
                  value={data.wmTags[2] || ''}
                  onChange={this.onChangeWeedmapTags(2)}
                  valueToRender={data.wmTags[2] || ''}
                  editMode={editMode}
                  MenuProps={{ className: 'no-backdrop-select' }}
                >
                  {thirdLevelCategories.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item.name}>
                        {item.name}
                      </MenuItem>
                    )
                  })}
                </EditableSelect>
              )) || <span>{data.wmTags[2] || ''}</span>}
            </TableCell>
            <TableCell>
              {(fourthLevelCategories.length && (
                <EditableSelect
                  value={data.wmTags[3] || ''}
                  onChange={this.onChangeWeedmapTags(3)}
                  valueToRender={data.wmTags[3] || ''}
                  editMode={editMode}
                  MenuProps={{ className: 'no-backdrop-select' }}
                >
                  {fourthLevelCategories.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    )
                  })}
                </EditableSelect>
              )) || <span>{data.wmTags[3] || ''}</span>}
            </TableCell>
          </Fragment>
        ) : null}
        <TableCell className="cell-wrap-word">
          {hasAccess() ? (
            <div className="pull-right">
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
              {!editMode ? (
                <Button className="danger-button margin" onClick={this.props.onDelete}>
                  Delete
                </Button>
              ) : null}
            </div>
          ) : null}
        </TableCell>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WeedmapInfo/WeedMapMenuList/WeedMapMenuListItem.js